export const zhTW = {
  upload: "上載",
  cancel: "取消",
  close: "關",
  uploading: "上傳中...",
  uploaded: "已上傳",
  fetching: "正在取得您的影像從 $1$...",
  poweredBy: "由 $1$ 提供",
  needHelp: "需要幫助嗎?",

  units: {
    px: "px",
    "%": "%",
    deg: "°",
  },

  errors: {
    response_not_ok: "我們在抓取這個檔案時發生錯誤",
    unable_to_search: "我們在搜尋時發生錯誤",
    invalid_service_url: "這不是一個 $1$ 網址",
    invalid_url: "這個網址似乎無效",
    upload_aborted: "您的上傳已取消",
    upload_error: "我們在上傳這個檔案時發生錯誤",
    file_type_not_allowed: "這個檔案類型不被允許",
    file_too_large: "您的檔案應該小於 $1$",
  },

  help: {
    loading: "讀取幫助中...",
    close: "關閉幫助",
  },

  services: {
    default: {
      heading: "選擇一個影像",
    },
    local: {
      title: "選擇檔案",
      button: "選擇一個檔案",
      or: "或",
      drop: "拖曳檔案至此",
    },
    camera: {
      title: "相機",
      button: "點擊照片",
      switch: "切換照片",
      waiting: "等待權限授權中...",
      unableToRead:
        "我們無法從您的相機讀取影像，這可能是因為您拒絕了授予權限或是因為您的裝置不支援存取相機",
    },
    microlink: {
      button: "匯入 $1$",
      label: "$1$ $2$ 網址",
      placeholder: "請輸入一個 $1$ 的 $2$ 網址",
      type: "post",
    },
    url: {
      title: "網址",
      label: "影像網址",
      placeholder: "請輸入一個影像網址",
    },
    instagram: {
      title: "Instagram",
    },
    facebook: {
      title: "Facebook",
    },
    flickr: {
      title: "Flickr",
      type: "圖像",
    },
    ninegag: {
      title: "9GAG",
      type: "圖像",
    },
    deviantart: {
      title: "DeviantArt",
    },
    artstation: {
      title: "ArtStation",
    },
    twitter: {
      title: "Twitter",
      type: "影像推文",
    },
    pinterest: {
      title: "Pinterest",
      type: "釘文",
    },
    flipboard: {
      title: "Flipboard",
      type: "文章",
    },
    fotki: {
      title: "Fotki",
      type: "影像",
    },
    linkedin: {
      title: "LinkedIn",
    },
    reddit: {
      title: "Reddit",
    },
    tumblr: {
      title: "Tumblr",
    },
    weheartit: {
      title: "We Heart It",
    },
    screenshot: {
      title: "螢幕截圖",
      button: "擷取螢幕截圖",
      label: "網頁網址",
      placeholder: "請輸入一個網頁網址",
      loading: "正在擷取螢幕截圖...",
    },
    search: {
      button: "搜尋 $1$",
      label: "找一張影像",
      placeholder: "請輸入關鍵字",
      imagesPoweredBy: "影像由 $1$ 提供",
    },
    giphy: {
      title: "GIPHY",
    },
    unsplash: {
      title: "Unsplash",
    },
    pixabay: {
      title: "Pixabay",
    },
    pexels: {
      title: "Pexels",
    },
  },

  effects: {
    preview: {
      title: "預覽",
    },
    filters: {
      title: "濾鏡",
    },
    crop: {
      title: "剪裁",
      aspectRatios: {
        free: "自由",
        square: "正方形",
      },
    },
    rotate: {
      title: "旋轉",
    },
    flip: {
      title: "翻轉",
      buttons: {
        horizontal: "水平",
        vertical: "垂直",
      },
    },
    sharpen: {
      title: "銳化",
    },
    blur: {
      title: "模糊",
    },
    brightness: {
      title: "亮度",
    },
    contrast: {
      title: "對比",
    },
    grayscale: {
      title: "灰階",
    },
    "hue-rotate": {
      title: "色相旋轉",
    },
    invert: {
      title: "負片效果",
    },
    saturate: {
      title: "飽和度",
    },
    sepia: {
      title: "懷舊(黃褐色)",
    },
  },
};
